import { buildApiRoute } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery ($) is loaded globally
class EmailValidation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      emailValidationError: "",
    }
    this.checkEmail = this.checkEmail.bind(this)
  }

  componentDidMount() {
    this.checkEmail(this.props.email)
  }

  checkEmail(email) {
    this.setState({ loading: true })
    $.post(buildApiRoute("validate/email_deliverable"), { email }, (data) => {
      this.setState({ loading: false, emailValidationError: "" })
    }).fail((data) => {
      this.setState({
        emailValidationError: data.responseJSON.error,
        loading: false,
      })
    })
  }

  renderLoadingView() {
    return (
      <div>
        <i
          style={{ fontSize: "2rem" }}
          className="fa-solid fa-spinner-third fa-spin text-muted"
        />
        <span className="px-2 text-sm text-gray-600">Validating email...</span>
      </div>
    )
  }

  renderResultView() {
    return (
      <span className="text-sm text-red-600">
        {this.state.emailValidationError}
      </span>
    )
  }

  render() {
    return (
      <div className="py-2">
        {this.state.loading && this.renderLoadingView()}
        {!this.state.loading &&
          this.state.emailValidationError !== "" &&
          this.renderResultView()}
      </div>
    )
  }
}

EmailValidation.propTypes = {
  email: PropTypes.string.isRequired,
}

export default EmailValidation
